(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ga-collection-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ga-copy-code')) {
    customElements.define(
      'ga-copy-code',
      class extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('button');
          const label = this.querySelector('[data-idle]');
          if (!button || !label) return;

          button.addEventListener('click', async () => {
            try {
              await navigator.clipboard.writeText(this.dataset.code);
            } catch (error) {
              return;
            }
            label.textContent = label.dataset.done;
            this.toggleAttribute('data-copied', true);
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              label.textContent = label.dataset.idle;
              this.removeAttribute('data-copied');
            }, 2000);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ga-collection-toolbar')) {
    customElements.define(
      'ga-collection-toolbar',
      class extends HTMLElement {
        connectedCallback() {
          this.sheet = this.querySelector('dialog');
          this.count = this.querySelector('[data-ga-count]');

          this.querySelector('[data-ga-sort]')?.addEventListener('click', () => this.openSort());
          this.querySelector('[data-ga-filter]')?.addEventListener('click', () => this.openFilters());

          this.sheet?.addEventListener('click', (event) => {
            // A click on the backdrop lands on the dialog element itself.
            if (event.target === this.sheet || event.target.closest('[data-ga-close]')) {
              this.sheet.close();
              return;
            }
            const option = event.target.closest('[data-value]');
            if (option) this.applySort(option.dataset.value);
          });

          // Filters applied in the drawer update the URL and re-render the grid
          // without a page load, so the badge is recounted from the URL.
          this.onChange = () => this.updateCount();
          window.addEventListener('popstate', this.onChange);
          const results = document.querySelector('results-list');
          if (results) {
            this.observer = new MutationObserver(this.onChange);
            this.observer.observe(results, { childList: true, subtree: true });
          }
        }

        disconnectedCallback() {
          window.removeEventListener('popstate', this.onChange);
          this.observer?.disconnect();
        }

        openSort() {
          const current = new URL(window.location.href).searchParams.get('sort_by') || this.dataset.defaultSort;
          for (const option of this.sheet.querySelectorAll('[data-value]')) {
            option.setAttribute('aria-pressed', String(option.dataset.value === current));
          }
          this.sheet.showModal();
        }

        applySort(value) {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          url.searchParams.delete('page');
          window.location.assign(url);
        }

        openFilters() {
          const drawer = document.getElementById('filters-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            document.querySelector('.facets-toggle__button')?.click();
          }
        }

        updateCount() {
          if (!this.count) return;
          const params = new URL(window.location.href).searchParams;
          let total = 0;
          let price = false;
          for (const [key] of params) {
            if (!key.startsWith('filter.')) continue;
            if (key.startsWith('filter.v.price.')) {
              price = true;
            } else {
              total += 1;
            }
          }
          if (price) total += 1;
          this.count.textContent = String(total);
          this.count.hidden = total === 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
